import {
  Layout,
  Typography,
  message,
  Spin,
  Badge,
  Input,
  Avatar,
  Tooltip
} from 'antd';
import {
  MailTwoTone,
  MobileTwoTone,
  DollarOutlined,
  DollarTwoTone,
  SearchOutlined,
  SettingOutlined,
  CheckCircleTwoTone
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { decryptData } from '../middleware/encryption';

const { Header } = Layout;
const { Text } = Typography;

export default function AppHeader() {
  const navigate = useNavigate();
  const [usageData, setUsageData] = useState();
  const [loading, setLoading] = useState(true);
  const [planType, setPlanType] = useState('Starter');

  const fetchUserCredits = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem('access_token');
      const myHeaders = new Headers();

      console.log(token);
      if (token) myHeaders.append("Authorization", `Bearer ${token}`);

      const response = await fetch("https://api.app.exellius.com/api/users/getUserPoints", {
        method: "GET",
        headers: myHeaders
      });

      const result = await response.json();
      if (result.data) {
        const decryptedResponse = decryptData(result.data);
        setUsageData(decryptedResponse.points);
      } else {
        message.error(result.message || "Failed to fetch user credits");
      }
    } catch (error) {
      console.error('Error fetching user credits:', error);
      message.error("An error occurred while fetching user credits");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUserCredits();
    const script = document.createElement('script');
    script.src = "https://salesiq.zohopublic.in/widget?wc=siq84646a54c0ed16a2fa31eb4a0c59a20fbefd8488b0d78e393036f03e317fc106";
    script.defer = true;
    script.id = "zsiqscript";
    document.body.appendChild(script);
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () { } };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const formatCredits = (credits) => {
    if (!credits && credits !== 0) return '-';
    if (credits >= 1000) return `${(credits / 1000).toFixed(1)}K`;
    return credits;
  };

  return (
    <Header style={{
      backgroundColor: 'transparent',
      padding: '10px 24px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }}>
      {/* Left - Empty or brand if needed */}
      <div style={{ fontWeight: 'bold', fontSize: 14 }}> {planType} :</div>

      {/* Center - Icons + Usage */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 48,
        padding: '8px 16px',
        borderRadius: 12,
      }}>
        {/* Total Credits */}
        <Tooltip title="Total Credits">
        <Badge count={formatCredits(usageData)} size="small" color="#9b5de5" >
          <DollarTwoTone style={{ fontSize: 24, color: "#a0a0a0",marginRight: 20 }} />
        </Badge>
        </Tooltip>
       

        {/* Email */}
        <Tooltip title="Email Credits">
        <Badge count={formatCredits(usageData)} size="small" color="#9b5de5" >
          <MailTwoTone style={{ fontSize: 24, color: "#a0a0a0",marginRight: 20 }} />
        </Badge>
        </Tooltip>

         <Tooltip title="Email verification Credits">
        <Badge count={formatCredits(usageData)} size="small" color="#9b5de5" >
          <CheckCircleTwoTone style={{ fontSize: 24, color: "#a0a0a0",marginRight: 20 }} />
        </Badge>
        </Tooltip>
        

        {/* Phone */}
        <Tooltip title="Phone Credits">
        <Badge count={formatCredits(Math.floor(usageData / 5))} size="small" color="#9b5de5" >
          <MobileTwoTone style={{ fontSize: 24, color: "#a0a0a0",marginRight: 20 }} />
        </Badge>
        </Tooltip>
       
      </div>

      {/* Right - Search, Avatar, Settings */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16,marginLeft: '20px' }}>
        
        <Avatar
          src="/avatar.png"
          size={32}
          style={{ cursor: 'pointer',width: 32, height: 32, borderRadius: '50%',background:"orange"  }}
        />

        <Tooltip title="Settings">
          <SettingOutlined style={{ fontSize: 18, color: '#888', cursor: 'pointer' }} onClick={()=>navigate("/settings")} />
        </Tooltip>
      </div>
    </Header>
  );
}
